export enum TesmostaDatalistValidatorValue {
  AuffaelligerWert = 0,
  KorrektWert = 1,
  AuswertungAusgeschlossen = 2,
  UngueltigerWert = 3
}

export const VALIDATOR_ERROR_NAMES = {
  REQUIRED_VALUE: 'requiredValue',
  MAX_LENGTH: 'maxlength',
  FORMAT_ERROR: 'fomatError',
  ONLY_ALPHABETS: 'onlyAlphabets',
  MIN_MAX_VALUE: 'minValueOrMaxValue',
  MUST_BE_M_OR_F: 'mustBeMorF',
  NOT_MATCH_TO_CONFIG_MANN_FRAU: 'NotMatchToTheConfigMannFrau',
  RANGE_ERROR: 'rangeError',
  AUFFAELLIGE_RANGE_ERROR: 'auffaelligeRangeError',
  VALUE_BUWAZ_IS_LESS_THAN_90: 'auffaelligeWertKleinerAls90Perc',
  VALUE_BUWAZ_IS_LESS_THAN_30: 'auffaelligeWertKleinerAls30Perc',
  UNIQUE_LAUFNUMMER: 'uniquelaufnummer',
  UNIQUE_CODIFICATION: 'uniquecodification',
  AUSBILDUNG_UNIQUE_CODIFICATION: 'ausbildungUniquecodification',
  NOT_ALLOWED_COMBINATION: 'notAllowedCombination',
  AUSBILDUNG_COMBINATION_NOT_ALLOWED: 'notAllowedAusbildungCombination',
  TOGGLE_VALUE: 'toggleValue',
  GENERIC_ERROR: 'genericError',
  TYPE_MISMATCH: 'typeMisMatch',
  GRUND_LOHN_LESS_THAN_BEZAHLT_STUNDEN: 'grundLhonNiedrigerAlsBezahltStunden',
  GRUND_LOHN_ZERO_ZULAGEN_13MONAT_SONDERZAHLUNGEN_ZERO:
    'grundLohnZeroZulagen13MonatslohnSonderzahlungenZero',
  GRUND_LOHN_ZERO_ZULAGEN_13MONAT_SONDERZAHLUNGEN_NOTZERO:
    'grundLohnZeroZulagen13MonatslohnSonderzahlungenNotZero',
  AUFFAELLIGE_FULL: 'fullvalues',
  AUFFAELLIGE_AUSBILDUNG_AUTONOMIE_VERANTWORTUNG:
    'AusbildungAutonomieVerantwortung',
  AUFFAELLIGE_AUSBILDUNG_VERANTWORTUNG: 'AusbildungVerantwortung',
  AUFFAELLIGE_AUTONOMIE_VERANTWORTUNG: 'AutonomieVerantwortung',
  AUFFAELLIGE_AUTONOMIE_KOERPERLICHE: 'autonomieKoerperliche',
  AUFFAELLIGE_SPEZIIALWISSEN_KOERPERLICHE: 'spezialwissenKoerperliche',
  AUFFAELLIGE_AUSBILDUNG_KOERPERLICHE: 'ausbildungKoerperlicheAuffaellig',
  AUFFAELLIGE_AUSBILDUNG_AUTONOMIE_KOERPERLICHE:
    'ausbildungAutonomieKoerperliche',
  AUFFAELLIGE_AUSBILDUNG_SPEZIIALWISSEN_KOERPERLICHE:
    'ausbildungSpezifischesKoerperliche',
  AUFFAELLIGE_AUTONOMIE_SPEZIIALWISSEN_KOERPERLICHE:
    'autonomieSpezifischesKoerperliche',
  AUFFAELLIGE_FULL_CASE_2: 'case2fullvalues',
  ALTER_DIENST_JAHRE_COMBINATION_NOT_ALLOWED: 'notAllowedAlterDienstjahre',
  BST_ANF_COMBINATION_NOT_ALLOWED: 'notAllowedBstAnf'
};

export enum YearsOfServiceOption {
  NumberOfYears = 1,
  YearOfEntry = 2,
  DateOfEntry = 3
}

export enum RulesPriorities {
  CaseRule1FirstBlock = 1,
  CaseRule1SecondBlock = 2,
  CaseRule2FirstBlock = 10,
  CaseRule2SecondBlock = 20
}
export enum AgeOption {
  AgeInYears = 1,
  YearOfBirth = 2,
  DateOfBirth = 3
}

export const PRIO_ALTER_OPTION = {
  AlterWichtigerAlsDienstjahre: true,
  DienstjahreWichtigerAlsAlter: false
};
